module.exports = __webpack_public_path__ + "static/Afolabi-463e6705b1919368eb270d449b22ebfa.png";